// baseURL.js

const baseURL = process.env.NODE_ENV === 'production' ? 'https://api.yt2short.com' : 'http://localhost:5000';
export default baseURL;